import React, { memo, useRef, useLayoutEffect } from 'react';
import usePrevious from '../Confirmation/hooks/usePrevious';
import './Confirmation.scss'
import cx from 'classnames';
// import './Confirmation'
import { SingleOTPInputProps } from './Confirmation.types';


export function SingleOTPInputComponent({
  focus,
  autoFocus,
  errors,
  ...props
}: SingleOTPInputProps) {
  const inputRef = useRef<HTMLInputElement>(null);
  const prevFocus = usePrevious(!!focus);
  const classes = cx("input", "textarea")
  useLayoutEffect(() => {
    if (inputRef.current) {
      if (focus && autoFocus) {
        inputRef.current.focus();
      }
      if (focus && autoFocus && focus !== prevFocus) {
        inputRef.current.focus();
        inputRef.current.select();
      }
    }
  }, [autoFocus, focus, prevFocus]);
  if(errors) {
            return <input  
            data-testid="otp-input"
            className={classes} type="range" ref={inputRef} {...props} />;
  } else {
    return <input className={classes} type="text" ref={inputRef} {...props} />;
  } 
}

const SingleOTPInput = memo(SingleOTPInputComponent);
export default SingleOTPInput;